import React, { useEffect, useState } from 'react';
import { BlockStack, Scrollable, Text, } from "@shopify/polaris";
import Language from '../../../../../i18n/Language';
import { cloneDeep } from 'lodash-es';

const t = Language;

const AnalyzeContent = (props) => {
    const {
        refresh,
        recordData
    } = props;

    // 分析步骤
    const [contentList, setContentList] = useState({
        0: {
            title: t("Research Topic"),
            desc: t("Research on 'Target keyword' and gathering SERP information."),
            status: 0,
        },
        1: {
            title: t("Analyzing SERP Result"),
            desc: t("Analyze the top {{v1}} Google-ranking articles to identify core topic intents.", 0),
            data: [],
            status: 0,
        },
        2: {
            title: t("Analyzing Reference Articles"),
            desc: t("Extracting semantic keywords and content structure from top-ranking page"),
            status: 0,
        },
        3: {
            title: t("Audit Page Content"),
            desc: t("Evaluating topic keyword coverage, content structure, and SEO issues."),
            status: 0,
        },
    });
    const [topicKeywordVal, setTopicKeywordVal] = useState('');

    useEffect(() => {
        const _r = recordData;
        let _contentList = cloneDeep(contentList);
        Object.values(_contentList).forEach((item, index) => {
            // 设置列表
            if (index === 1) {
                item.data = _r.serp_sites || [];
            }
            // 设置状态
            if (_r.current_step >= (index + 1)) {
                if (_r.current_step === (index + 1) && _r.current_status !== 2) {
                    item.status = 2;
                } else {
                    item.status = 1;
                }
            }
            if (_r.current_step === index && ![2, 3].includes(_r.current_status)) {
                item.status = 2;
            }
            if (_r.current_step < index + 1) {
                item.status = 0;
            }
        })
        setTopicKeywordVal(_r.keyword);

        // 设置长度
        if (_contentList[1].status === 1) {
            _contentList[1].desc = t("Analyze the top {{v1}} Google-ranking articles to identify core topic intents.", _contentList[1].data?.length || 0);
        } else {
            _contentList[1].desc = t("Analyze the top {{v1}} Google-ranking articles to identify core topic intents.", _contentList[1].data?.length || _r.serp_sites?.length || 0);
        }
        setContentList(_contentList);
    }, [recordData]);

    // 步数icon
    const stepIconArr = {
        1: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.001 2C17.5235 2.00026 22.0008 6.4775 22.001 12C22.001 17.5227 17.5236 21.9997 12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00119 6.47733 6.47826 2 12.001 2ZM12.001 3.5C7.30669 3.5 3.50119 7.30576 3.50098 12C3.50098 16.6944 7.30656 20.5 12.001 20.5C16.6952 20.4997 20.501 16.6943 20.501 12C20.5008 7.30592 16.695 3.50026 12.001 3.5Z" fill="#CCCCCC" />
            <path d="M9.04901 16V14.858L12.0788 11.8878C12.3686 11.5952 12.6101 11.3352 12.8033 11.108C12.9964 10.8807 13.1413 10.6605 13.2379 10.4474C13.3345 10.2344 13.3828 10.0071 13.3828 9.76562C13.3828 9.49006 13.3203 9.25426 13.1953 9.05824C13.0703 8.85938 12.8984 8.70597 12.6797 8.59801C12.4609 8.49006 12.2124 8.43608 11.9339 8.43608C11.647 8.43608 11.3956 8.49574 11.1797 8.61506C10.9638 8.73153 10.7962 8.89773 10.6768 9.11364C10.5604 9.32955 10.5021 9.58665 10.5021 9.88494H8.99787C8.99787 9.33097 9.12429 8.84943 9.37713 8.44034C9.62997 8.03125 9.97798 7.71449 10.4212 7.49006C10.8672 7.26562 11.3786 7.15341 11.9553 7.15341C12.5405 7.15341 13.0547 7.26278 13.4979 7.48153C13.9411 7.70028 14.2848 8 14.5291 8.38068C14.7763 8.76136 14.8999 9.19602 14.8999 9.68466C14.8999 10.0114 14.8374 10.3324 14.7124 10.6477C14.5874 10.9631 14.3672 11.3125 14.0518 11.696C13.7393 12.0795 13.3004 12.544 12.7351 13.0895L11.2308 14.6193V14.679H15.032V16H9.04901Z" fill="#B5B5B5" />
        </svg>,
        2: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.001 2C17.5235 2.00026 22.0008 6.4775 22.001 12C22.001 17.5227 17.5236 21.9997 12.001 22C6.47813 22 2 17.5228 2 12C2.00021 6.47733 6.47826 2 12.001 2ZM12.001 3.5C7.30669 3.5 3.50119 7.30576 3.50098 12C3.50098 16.6944 7.30656 20.5 12.001 20.5C16.6952 20.4997 20.501 16.6943 20.501 12C20.5008 7.30592 16.695 3.50026 12.001 3.5Z" fill="#CCCCCC" />
            <path d="M11.9995 16.1193C11.3858 16.1193 10.8404 16.0142 10.3631 15.804C9.88867 15.5937 9.51367 15.3011 9.2381 14.9261C8.96254 14.5511 8.81623 14.1179 8.79918 13.6264H10.4015C10.4157 13.8622 10.4938 14.0682 10.6358 14.2443C10.7779 14.4176 10.9668 14.5526 11.2026 14.6491C11.4384 14.7457 11.7026 14.794 11.9952 14.794C12.3077 14.794 12.5847 14.7401 12.8262 14.6321C13.0676 14.5213 13.2566 14.3679 13.3929 14.1719C13.5293 13.9759 13.5961 13.75 13.5932 13.4943C13.5961 13.2301 13.5279 12.9972 13.3887 12.7955C13.2495 12.5937 13.0478 12.4361 12.7836 12.3224C12.5222 12.2088 12.2069 12.152 11.8375 12.152H11.0662V10.9332H11.8375C12.1415 10.9332 12.4071 10.8807 12.6344 10.7756C12.8645 10.6705 13.0449 10.5227 13.1756 10.3324C13.3063 10.1392 13.3702 9.91619 13.3674 9.66335C13.3702 9.41619 13.3148 9.2017 13.2012 9.01989C13.0904 8.83523 12.9327 8.69176 12.7282 8.58949C12.5265 8.48722 12.2892 8.43608 12.0165 8.43608C11.7495 8.43608 11.5023 8.48437 11.275 8.58097C11.0478 8.67756 10.8645 8.81534 10.7253 8.99432C10.5861 9.17045 10.5123 9.38068 10.5037 9.625H8.98242C8.99379 9.13636 9.13441 8.70739 9.4043 8.33807C9.67702 7.96591 10.0407 7.67614 10.4952 7.46875C10.9498 7.25852 11.4597 7.15341 12.025 7.15341C12.6074 7.15341 13.1131 7.26278 13.5421 7.48153C13.9739 7.69744 14.3077 7.98864 14.5435 8.35511C14.7793 8.72159 14.8972 9.12642 14.8972 9.5696C14.9 10.0611 14.7551 10.473 14.4625 10.8054C14.1728 11.1378 13.7921 11.3551 13.3205 11.4574V11.5256C13.9341 11.6108 14.4043 11.8381 14.731 12.2074C15.0605 12.5739 15.2239 13.0298 15.2211 13.5753C15.2211 14.0639 15.0819 14.5014 14.8034 14.8878C14.5279 15.2713 14.1472 15.5724 13.6614 15.7912C13.1784 16.0099 12.6245 16.1193 11.9995 16.1193Z" fill="#B5B5B5" />
        </svg>,
        3: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.001 2C17.5235 2.00026 22.0008 6.4775 22.001 12C22.001 17.5227 17.5236 21.9997 12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00119 6.47733 6.47826 2 12.001 2ZM12.001 3.5C7.30669 3.5 3.50119 7.30576 3.50098 12C3.50098 16.6944 7.30656 20.5 12.001 20.5C16.6952 20.4997 20.501 16.6943 20.501 12C20.5008 7.30592 16.695 3.50026 12.001 3.5Z" fill="#CCCCCC" />
            <path d="M8.6218 14.3807V13.1236L12.3249 7.27273H13.3732V9.0625H12.734L10.2411 13.0128V13.081H15.4102V14.3807H8.6218ZM12.7852 16V13.9972L12.8022 13.4347V7.27273H14.2937V16H12.7852Z" fill="#B5B5B5" />
        </svg>
    }

    // loading 模块
    const loadingIcon = (loading = true) => {
        return <div className="task_loading_icon_box">
            <span className="task_loading_icon opt_icon" style={{ opacity: loading ? 1 : 0 }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12.0004" r="10" fill="var(--color-primary)" />
                    <g clipPath="url(#paint0_angular_6228_10823_clip_path)" data-figma-skip-parse="true">
                        <g transform="matrix(-0.00557143 0.00342857 -0.00342857 -0.00557143 12 12)">
                            <foreignObject x="-1682.4" y="-1682.4" width="3364.81" height="3364.81">
                                <div
                                    xmlns="http://www.w3.org/1999/xhtml"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        opacity: 1,
                                        background: `
                                    conic-gradient(
                                        from 90deg,
                                        rgba(209, 209, 209, 0.554) 0deg,
                                        rgba(255, 255, 255, 1) 127.631deg,
                                        rgba(153, 153, 153, 0) 201.449deg,
                                        rgba(209, 209, 209, 0.554) 360deg
                                    )
                                `,
                                    }}
                                />
                            </foreignObject>
                        </g>
                    </g>
                    <path d="M12 6C12.5523 6 13 6.44772 13 7C13 7.55229 12.5523 8.00001 12 8.00001C11.2088 8.00001 10.4351 8.23431 9.77731 8.67384C9.11957 9.11336 8.60738 9.73888 8.30465 10.4697C8.00201 11.2006 7.9228 12.0045 8.07711 12.7803C8.23145 13.5562 8.61243 14.2687 9.17184 14.8282C9.73125 15.3876 10.4438 15.7685 11.2197 15.9229C11.9955 16.0772 12.7994 15.998 13.5303 15.6953C14.2611 15.3926 14.8866 14.8804 15.3262 14.2227C15.7657 13.5649 16 12.7911 16 12C16 11.4477 16.4477 11 17 11C17.5523 11 18 11.4477 18 12C18 13.1865 17.6483 14.3464 16.9893 15.333C16.33 16.3197 15.3922 17.0889 14.2959 17.543C13.1995 17.9971 11.9929 18.1163 10.8291 17.8848C9.66531 17.6533 8.59681 17.0813 7.75778 16.2422C6.91874 15.4032 6.34675 14.3347 6.11519 13.1709C5.88368 12.0071 6.00288 10.8005 6.45699 9.70411C6.91112 8.60775 7.68026 7.67004 8.66696 7.01075C9.65355 6.35167 10.8135 6 12 6Z" data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.35453048348426819},{&#34;color&#34;:{&#34;r&#34;:0.60000002384185791,&#34;g&#34;:0.60000002384185791,&#34;b&#34;:0.60000002384185791,&#34;a&#34;:0.0},&#34;position&#34;:0.55958020687103271}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.35453048348426819},{&#34;color&#34;:{&#34;r&#34;:0.60000002384185791,&#34;g&#34;:0.60000002384185791,&#34;b&#34;:0.60000002384185791,&#34;a&#34;:0.0},&#34;position&#34;:0.55958020687103271}],&#34;transform&#34;:{&#34;m00&#34;:-11.142859458923340,&#34;m01&#34;:-6.8571419715881348,&#34;m02&#34;:21.000001907348633,&#34;m10&#34;:6.8571419715881348,&#34;m11&#34;:-11.142859458923340,&#34;m12&#34;:14.142859458923340},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}" />
                    <defs>
                        <clipPath id="paint0_angular_6228_10823_clip_path"><path d="M12 6C12.5523 6 13 6.44772 13 7C13 7.55229 12.5523 8.00001 12 8.00001C11.2088 8.00001 10.4351 8.23431 9.77731 8.67384C9.11957 9.11336 8.60738 9.73888 8.30465 10.4697C8.00201 11.2006 7.9228 12.0045 8.07711 12.7803C8.23145 13.5562 8.61243 14.2687 9.17184 14.8282C9.73125 15.3876 10.4438 15.7685 11.2197 15.9229C11.9955 16.0772 12.7994 15.998 13.5303 15.6953C14.2611 15.3926 14.8866 14.8804 15.3262 14.2227C15.7657 13.5649 16 12.7911 16 12C16 11.4477 16.4477 11 17 11C17.5523 11 18 11.4477 18 12C18 13.1865 17.6483 14.3464 16.9893 15.333C16.33 16.3197 15.3922 17.0889 14.2959 17.543C13.1995 17.9971 11.9929 18.1163 10.8291 17.8848C9.66531 17.6533 8.59681 17.0813 7.75778 16.2422C6.91874 15.4032 6.34675 14.3347 6.11519 13.1709C5.88368 12.0071 6.00288 10.8005 6.45699 9.70411C6.91112 8.60775 7.68026 7.67004 8.66696 7.01075C9.65355 6.35167 10.8135 6 12 6Z" /></clipPath></defs>
                </svg>
            </span>
            <span className="task_finish_icon opt_icon" style={{ opacity: loading ? 0 : 1 }}>
                <svg width="21" height="21" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12.0004" r="10" fill="var(--color-primary)" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M16.8841 8.29289C17.2391 8.68342 17.2391 9.31658 16.8841 9.70711L11.4296 15.7071C11.0746 16.0976 10.499 16.0976 10.1439 15.7071L7.41666 12.7071C7.06164 12.3166 7.06164 11.6834 7.41666 11.2929C7.77168 10.9024 8.34728 10.9024 8.70231 11.2929L10.7868 13.5858L15.5985 8.29289C15.9535 7.90237 16.5291 7.90237 16.8841 8.29289Z" fill="#FDFDFF" />
                </svg>
            </span>
        </div>
    }

    // 获取域名
    const domainFromUrl = (url) => {
        if (!url || typeof url !== 'string') return '';
        try {
            const normalized = /^https?:\/\//i.test(url) ? url : `https://${url}`;
            return new URL(normalized).hostname.replace(/^www\./i, '');
        } catch {
            return url;
        }
    };

    // 骨架屏 模块
    const skeltonLine = <div className="skelton_line">
        <div className="s_line_short"></div>
        <div className="s_line_long"></div>
        <div className="s_line_long"></div>
    </div>

    // 子步骤 - 分析SERP数据
    const analyzeProgress = <div className="audit_analyze_content" style={refresh ? { padding: '0 0 16px' } : {}}>
        <BlockStack gap={400}>
            <div className="research_topic_step">
                {
                    Object.values(contentList).map((item, index) => {
                        const c_index = refresh ? index - 2 : index;
                        return (refresh && index <= 1) ? null : <div className="task_container" key={item.title}>
                            <div className="task_left_icon">
                                {
                                    Boolean(item?.status === 0) ? <span>{c_index === 0 ? loadingIcon(false) : stepIconArr[c_index]}</span> : loadingIcon(item?.status !== 1)
                                }
                                {
                                    index < 3 && <div className={`${Boolean(item.status === 1) ? 'solid_line' : ''} task_line`}></div>
                                }
                            </div>
                            {
                                Boolean(item.status === 0) ? skeltonLine : <div className="task_right_info">
                                    <Text variant="headingMd" as="h2" fontWeight="semibold">{t(item.title)}</Text>
                                    <div className={`${Boolean(item.status === 2) ? 'animate_p' : ''}`}>
                                        {
                                            index === 0 ? <Text variant="bodyMd" as="p" tone='subdued'>
                                                {t("Research on")} "{topicKeywordVal}" {t("and gathering SERP information.")}
                                            </Text> : <Text variant="bodyMd" as="p" tone='subdued'>{item.desc}</Text>
                                        }
                                    </div>
                                    {
                                        (index === 1 && Array.isArray(item.data) && item.data.length > 0) && (
                                            <div className='site_list'>
                                                <Scrollable shadow style={{ maxHeight: '200px' }}>
                                                    <BlockStack gap="200">
                                                        {item.data.map((row, i) => (
                                                            <div key={`${row.id}-${i}`} className='site_list_item'>
                                                                <BlockStack gap={100}>
                                                                    <Text variant="bodyMd" as="p" fontWeight="semibold" breakWord>
                                                                        {row.title}
                                                                    </Text>
                                                                    <Text variant="bodySm" as="p" tone="disabled" breakWord>
                                                                        {domainFromUrl(row.url)}
                                                                    </Text>
                                                                </BlockStack>
                                                            </div>
                                                        ))}
                                                    </BlockStack>
                                                </Scrollable>
                                            </div>
                                        )
                                    }
                                </div>
                            }
                        </div>
                    })
                }
            </div>
        </BlockStack>
    </div>

    return analyzeProgress;
}


export default AnalyzeContent;